














import { Multipane, MultipaneResizer } from 'vue-multipane'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import Question from '../models/Question'
import questionParser from '../../../helpers/question-parser'
import { State, Getter, Action, Mutation } from '../store-helper'
import QuestionBodyPreviewComponent from './QuestionBodyPreviewComponent.vue'
import ExplanationPreviewComponent from './ExplanationPreviewComponent.vue'
import QuestionComponent from './QuestionComponent.vue'
import {
  State as StateEditor,
  Getter as GetterEditor,
  Action as ActionEditor,
  Mutation as MutationEditor
} from '../store-helper'
import { qEditorState } from '../stores'

@Component({
  components: {
    QuestionBodyPreviewComponent,
    ExplanationPreviewComponent,
    QuestionComponent,
    Multipane,
    MultipaneResizer
  }
})
export default class QuestionPreviewComponent extends Vue {
  get questions() {
    return qEditorState.questions
  }

  get question() {
    return qEditorState.question
  }

  get groupQuestions(): Question[] {
    if (!this.question) {
      return []
    }
    const groupQuestions = this.questions.filter((question) => question.group === this.question!.group)
    return groupQuestions
  }
}
